import React from "react";
import styles from "./GameCard.module.css";
import clsx from "clsx";
import { isImage, isVideo } from "../../util/Validator";
import AutoPlayMutedVideo from "../AutoPlayMutedVideo";
import ImageComponent from "../ImageComponent";

interface GameCardProps {
  label: string;
  highlight: boolean;
  icon: string;
  onClick: () => void;
  isFilterApplied?: boolean;
}

const GameCard: React.FC<GameCardProps> = ({
  label,
  highlight,
  icon,
  onClick,
  isFilterApplied = false,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault();
    onClick();
  };

  return (
    <div
      className={clsx(styles["container"], { [styles["bg"]]: isImage(icon) })}
      onClick={handleClick}
    >
      <div
        className={clsx(
          styles["game-card"],
          {
            [styles["highlight"]]: highlight,
          },
          { [styles["bg"]]: isImage(icon) }
        )}
      >
        <div
          className={clsx(
            styles["icon"],
            {
              [styles["icon-filter"]]: isFilterApplied,
            },
            { [styles["highlight"]]: highlight }
          )}
        >
          {isImage(icon) && <ImageComponent src={icon} alt="Icon" />}
          {isVideo(icon) && <AutoPlayMutedVideo videoSrc={icon} />}
        </div>
      </div>
      <div
        className={clsx(styles["label"], "paragraph03", {
          [styles["highlight"]]: highlight,
        })}
      >
        {label}
      </div>
    </div>
  );
};

export default GameCard;
